<section>
  <div class="faq-section">
    <h2>Frequently Asked Questions </h2>
    <h3>AT&T Device Deployment Program </h3>
    <p> Lorem Impsum Lorem Ipsum .. </p>
    <app-accordion [accordion]="faqDetails.faq" [accordionController] = true >
      <!--  <app-accordion-list *ngFor="let faq of faqValues.faq; let i = index" [item]='i' [count]='faqValues.faq.length' [occontrol]="false" [accheading] = 'faq.question'> -->
      <app-accordion-list *ngFor="let faq of faqDetails.faq; let i = index" [option]='faq' [isSubAccordion] = true >
        <div class="acc-content"> {{faq.description.answer}} </div>
        <div *ngIf="faq.description.links">
          <div *ngFor="let links of  faq.description.links; let j = index">
            <div *ngIf="links.type == 'pdf'">
              <a href='{{links.url}}'> {{links.name}} </a>
            </div>
            <div *ngIf="links.type == 'video'">
              <!--att-gvp video="links.url"></att-gvp-->
            </div>
          </div>
        </div>
        <!-- Sub accordion Start Here  -->
        <app-accordion [accordion]="faq.description.subfaq"  [accordionController] = false  >
          <app-accordion-list *ngFor="let sf of faq.description.subfaq; let i = index" [option]='sf' [isSubAccordion] = false > 
            <div class="acc-content"> {{sf.description.answer}} </div>
            <div *ngIf="sf.description.links">
              <div *ngFor="let links of  sf.description.links; let j = index">
                <div *ngIf="links.type == 'pdf'">
                  <a href='{{links.url}}'> {{links.name}} </a>
                </div>
                <div *ngIf="links.type == 'video'">
                  <!--att-gvp video="links.url"></att-gvp-->
                </div>
              </div>
            </div>
          </app-accordion-list>
        </app-accordion>  
        <!-- Sub accordion ENds here -->
      </app-accordion-list>
    </app-accordion>
  </div>
</section>